import { Routes, Route } from "react-router-dom";
import ControlTowerList from "./ControlTowerList";
import ControlTowerBoard from "./ControlTowerBoard";

const index = () => {
	return (
		<Routes>
			<Route path='/list' element={<ControlTowerList />} />
			<Route path='/board' element={<ControlTowerBoard />} />
		</Routes>
	);
};

export default index;
